import React from 'react';
import {
  Stack,
  Box,
  Text,
  Heading,
  OrderedList,
  ListItem,
} from '@chakra-ui/react';
import CollapsibleItems from '../../components/shared/CollapsibleItems';

const FAQ_ITEMS = [
  {
    title: 'Q: What does your interview process consist of?',
    content: (
      <>
        <Text mb="3">A: Our process generally goes like this:</Text>
        <OrderedList ml="10" spacing="3">
          <ListItem>
            We review your application, looking for applicable experience and
            attributes we believe would make you successful in the role.
          </ListItem>
          <ListItem>
            You’ll have an introductory call where we’ll provide an overview of
            HOVER and the role. We’ll also begin to assess your qualifications
            and answer any questions you may have.
          </ListItem>
          <ListItem>
            You&apos;ll meet with your new manager or another team member. Here
            we’ll do a deeper dive into your background, which could include a
            live technical assessment or take-home challenge to be completed
            when convenient for you.
          </ListItem>
          <ListItem>
            Our virtual onsite interview is usually the final step in the
            interview process. You’ll meet with multiple members of the
            immediate team you’re interviewing with as well as a
            cross-functional teammate or two. We’ll assess technical and
            non-technical competencies as well as values alignment.
          </ListItem>
        </OrderedList>
        <Text mt="3">
          Please note that this is a generalization, and for a more specific
          understanding of the interview process for the role you’ve applied to
          please ask your Recruiter. Our goal is to provide ample opportunity
          for you to demonstrate your ability to succeed in the role. We believe
          the best interview processes are objective, transparent and
          consistent, and that is what we aim to provide you with.{' '}
        </Text>
      </>
    ),
  },
  {
    title: 'Q: What is your current work from home policy?',
    content: (
      <Stack spacing="3">
        <Text mb="2">
          A: We see value in having offices where employees gather and
          collaborate. We also know that employees want more flexibility in
          their work schedules so we practice a hybrid model.
        </Text>
        <Text>
          To us, hybrid means that all employees will either be ‘in office’ or
          ‘fully remote.’ Employees who are in office will be expected to go
          into the office at least 2-3 days / week. Those who are fully remote
          will have opportunities to travel to our offices at certain times.
          Some employees will need to be on-site more based on the nature of
          their roles. We will not define success by total time spent in the
          office.
        </Text>
      </Stack>
    ),
  },
  {
    title: 'Q: Will my interview be in-person or remote?',
    content:
      'A: All of our interviews are still being conducted remotely. We are prioritizing the wellbeing of our employees and candidates, as well as trying to provide a consistent interview process for all candidates. We primarily use Zoom video conferencing for our interview format.',
  },
  {
    title: 'Q: What is HOVER’s compensation philosophy?',
    content:
      'A: Our goal is to have transparent, equitable, rigorous, and responsible compensation practices. We take a market based approach and use best-in-class compensation data sources to help define compensation bands for each role, level and location. While being paid fairly and competitively are important, we believe compensation is only one part of a much larger picture of why you join and stay at HOVER. The most meaningful thing we can provide is an exceptional work experience.',
  },
  {
    title: 'Q: How should I prepare for my HOVER interview?',
    content:
      'A:  Ahead of panel interviews with our team, your recruiter will schedule a call to go over what to expect and any role specific information. We’ll also share some additional resources along the way that include information about our company’s history, values, and general interviewing best practices. One of the best ways you can prepare for your interview and conversations with our team is to download the HOVER App and experience our product for yourself.',
  },
  {
    title: 'Q: Does HOVER have an intern program?',
    content:
      'A: Yes, we absolutely have an intern program. Our summer 2021 class of interns were hired across six departments and enriched HOVER with diversity, intelligence and drive. We’ve converted several interns to full-time employees over the years, which is something we’re really proud of and expect to do more of in the future.',
  },
  {
    title: 'Q: What benefits does HOVER offer employees?',
    content:
      'A: We offer employees competitive salaries, meaningful equity and comprehensive medical, dental and vision benefits. We have a flexible vacation policy and employees have access to wellbeing and learning resources like management training, conferences, and online learning platforms. We support families and have generous parental leave benefits and help employees navigate how to use them. We equip our teams with the best tools, give a stipend to purchase the right gear for working at home, and much more.',
  },
];

const FAQSection = () => (
  <Box backgroundColor="gray.50" p="5" id="faq">
    <Box maxW="5xl" mx="auto">
      <Heading
        mt="14"
        mb="20"
        textAlign="center"
        fontSize="4xl"
        fontWeight="extrabold"
      >
        Frequently Asked Questions
      </Heading>
      <CollapsibleItems items={FAQ_ITEMS} isUnderlined isInitiallyOpen />
    </Box>
  </Box>
);

export default FAQSection;
